import React from 'react';
import checkmark_dark from '../../assets/checkmark-dark.svg';

const CHECK_PATH =
  'M10.6251 14.0798L15.1864 9.16604C15.3856 8.9532 15.655 8.83374 15.9359 8.83374C16.2168 8.83374 16.4863 8.9532 16.6855 9.16604C16.7852 9.27227 16.8643 9.39865 16.9182 9.53791C16.9722 9.67716 17 9.82652 17 9.97737C17 10.1282 16.9722 10.2776 16.9182 10.4168C16.8643 10.5561 16.7852 10.6825 16.6855 10.7887L11.3694 16.5023C11.1713 16.7134 10.904 16.8325 10.6251 16.8337C10.4852 16.8346 10.3465 16.8058 10.2169 16.7489C10.0874 16.692 9.96957 16.6082 9.87022 16.5023L7.37164 13.8055C7.26034 13.7031 7.16995 13.577 7.10613 13.4352C7.04231 13.2935 7.00645 13.139 7.00079 12.9817C6.99514 12.8243 7.01981 12.6673 7.07326 12.5207C7.12672 12.3741 7.2078 12.2409 7.31141 12.1295C7.41503 12.0182 7.53894 11.931 7.67538 11.8736C7.81182 11.8161 7.95784 11.7896 8.10426 11.7957C8.25069 11.8018 8.39437 11.8403 8.52627 11.9089C8.65818 11.9775 8.77548 12.0746 8.87079 12.1943L10.6251 14.0798Z';

/** Same glyph as checkmark-dark.svg, with a configurable circle colour. */
export const ChecklistCheckIcon = ({ fill = '#19B361', size = 24 }) => (
  <svg width={size} height={(size * 25) / 24} viewBox="0 0 24 25" fill="none" aria-hidden="true" className="shrink-0">
    <rect x="2" y="2.83374" width="20" height="20" rx="10" fill={fill} />
    <path d={CHECK_PATH} fill="white" />
  </svg>
);

/**
 * `modifiers.checkmarkFill` recolors the check circle (brands other than the
 * default green). Without it the original asset is used.
 */
const UpsellsChecklist = ({ content, modifiers = /** @type {{ checkmarkFill?: string }} */ ({}) }) => {
  const { checkmarkFill } = modifiers;

  return (
    <>
      {content &&
        content.map((feature, index) => {
          return (
            <div
              key={index}
              className={`flex items-start gap-[10px] ${index !== content.length - 1 ? 'mb-[16px]' : ''}`}
            >
              {checkmarkFill ? (
                <ChecklistCheckIcon fill={checkmarkFill} />
              ) : (
                <img src={checkmark_dark} alt="green_check" />
              )}
              <p
                className="font-inter text-[18px]/[22px] tracking-[-0.04em]"
                dangerouslySetInnerHTML={{ __html: feature }}
              ></p>
            </div>
          );
        })}
    </>
  );
};

export default UpsellsChecklist;
